// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DeleteCashflowMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteCashflowMutation = { __typename?: 'Mutation', deleteCashflows: number };

export const Operations = {
  Mutation: {
    DeleteCashflow: 'DeleteCashflow' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const DeleteCashflowDocument = gql`
    mutation DeleteCashflow($id: ID!) {
  deleteCashflows(ids: [$id])
}
    `;
export type DeleteCashflowMutationFn = Apollo.MutationFunction<DeleteCashflowMutation, DeleteCashflowMutationVariables>;

/**
 * __useDeleteCashflowMutation__
 *
 * To run a mutation, you first call `useDeleteCashflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCashflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCashflowMutation, { data, loading, error }] = useDeleteCashflowMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCashflowMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCashflowMutation, DeleteCashflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCashflowMutation, DeleteCashflowMutationVariables>(DeleteCashflowDocument, options);
      }
export type DeleteCashflowMutationHookResult = ReturnType<typeof useDeleteCashflowMutation>;
export type DeleteCashflowMutationResult = Apollo.MutationResult<DeleteCashflowMutation>;
export type DeleteCashflowMutationOptions = Apollo.BaseMutationOptions<DeleteCashflowMutation, DeleteCashflowMutationVariables>;